import { getConvenienceVariables } from '../convenienceVariables';
/*
  The commented out text above each variable
  should match the condition's name in Kentico
  and the variable key should match its codename
*/
export const conditions = {
    // User is a Fidelity integrated user
    global_condition_is_fidelity_user: (data) => {
        const mode = data.config.alexMode;
        return (data.config.partnerId === 'fidelity' &&
            (mode === 'enroll' || mode === 'browse'));
    },
    // User is expecting a pregnancy this year
    global_condition_user_expecting_pregnancy: (data) => {
        return data.user.Global.expectsMaternity === true ? true : false;
    },
    // User has not completed all available modules yet
    global_condition_has_rec_module: (data) => {
        const convVars = getConvenienceVariables(data);
        return typeof convVars.recommendedModule === 'string';
    },
};
//# sourceMappingURL=global.js.map